export default class ApiError extends Error {
  constructor(name, message) {
    super('ApiError');
    this.name = name;
    this.message = message;
  }
}
